export * from './getAttribute';
